import React from "react";
import CustomModal from "common/components/CustomModal/CustomModal";
import {
	ModalHeader,
	ModalBody,
	ModalPanel,
} from "common/components/CustomModal/Modal/ModalFrame";
import {
	GetCurrentGamePrefix
} from "common/constants/Games";
import { changeUrl } from "../../../history";
import ModalHelper from "../../../helpers/modalHelper";

export default function OneTimeSurveyNotify(props) {
	const targetUrl = `${GetCurrentGamePrefix()}/survey`;
	const onClick = (e) => {
		e.preventDefault();

		ModalHelper.closeModal();
		changeUrl(targetUrl);
	};

	return (
		<CustomModal>
			<ModalPanel>
				<ModalHeader>{props.header ?? "Survey Based Picks"}</ModalHeader>
				<ModalBody>
					<div>
						A Survey will be used in place of the playoff picks. <br />
						To make your playoff picks <a href={targetUrl} onClick={onClick} style={{ cursor: "pointer" }}>Click Here</a>
					</div>
					<br />
					<div>
						Note: You will be able to check your score using the SCORE button. <br />
						This can be found next to your nameplate on the swiss stage screen.
					</div>
				</ModalBody>
			</ModalPanel>
		</CustomModal>
	);
}
